import { HTTP } from '@/http-common'
import router from '@/router'

import {
  CONTACT_SUCCESS,
  CONTACT_UPDATE_SUCCESS,
  CONTACT_DELETE_SUCCESS
} from '@/assets/data/messages'

const state = {
  contacts: null
}
const getters = {
  contacts: s => s.contacts
}
const actions = {
  getContacts({ commit, getters }) {
    HTTP.get('/contacts?ownerId=' + getters.user.Id).then(response =>
      commit('SET_CONTACTS', response.data)
    )
  },
  createContact({ commit, getters }, contact) {
    const newContact = Object.assign({ OwnerId: getters.user.Id }, contact)
    HTTP.post('/contacts', newContact).then(response => {
      commit('ADD_CONTACT', response.data)
      commit('SET_MESSAGE', CONTACT_SUCCESS)
    })
  },
  updateContact({ commit }, contact) {
    HTTP.post('contacts', contact).then(response => {
      commit('UPDATE_CONTACT', response.data)
      commit('SET_MESSAGE', CONTACT_UPDATE_SUCCESS)
    })
  },
  addNote({ commit }, contact) {
    HTTP.post('contacts', contact).then(response => {
      commit('UPDATE_CONTACT', response.data)
    })
  },
  deleteContact({ commit }, contactId) {
    HTTP.delete('contacts/' + contactId).then(() => {
      commit('DELETE_CONTACT', contactId)
      commit('SET_MESSAGE', CONTACT_DELETE_SUCCESS)
      router.push({ name: 'Contacts' })
    })
  },
  removeNote({ commit }, contact) {
    HTTP.post('contacts', contact).then(response => {
      commit('UPDATE_CONTACT', response.data)
      commit('SET_MESSAGE', CONTACT_UPDATE_SUCCESS)
    })
  },
  editNote({ commit }, contact) {
    HTTP.post('contacts', contact).then(response => {
      commit('UPDATE_CONTACT', response.data)
      commit('SET_MESSAGE', CONTACT_UPDATE_SUCCESS)
    })
  }
}
const mutations = {
  SET_CONTACTS(s, contacts) {
    s.contacts = contacts
  },
  ADD_CONTACT(s, contact) {
    s.contacts.push(contact)
    router.push({ name: 'Contacts' })
  },
  UPDATE_CONTACT(s, contact) {
    s.contacts = s.contacts.map(c => (c.Id === contact.Id ? contact : c))
  },
  DELETE_CONTACT(s, contactId) {
    s.contacts = s.contacts.filter(c => c.Id !== contactId)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
